import { useCallback, type ChangeEvent } from "react";
import { useCalibration } from "../../contexts/CalibrationContext";
import Section from "../layout/Section";
import InfoTooltip from "../layout/InfoTooltip";

// TODO: In the new flow, the survey file is already in S3 (uploaded via the Upload page).
// Need backend endpoint to serve the S3 file URL so it can be loaded into the canvas.
// For now, keep the local file upload working as a fallback.

export default function SurveyUpload() {
  const { loadSurvey, isSurveyLoaded } = useCalibration();

  const handleFileChange = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) return;

      const fileType = file.type;

      if (fileType === "application/pdf") {
        const arrayBuffer = await file.arrayBuffer();
        loadSurvey("pdf", arrayBuffer, file);
      } else if (fileType.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (event) => {
          loadSurvey("image", event.target!.result as string, file);
        };
        reader.readAsDataURL(file);
      }
    },
    [loadSurvey],
  );

  return (
    <Section title="Upload Property's Survey">
      <input
        type="file"
        accept="image/jpeg, image/jpg, application/pdf, image/png"
        onChange={handleFileChange}
        className="bg-[#2f5241] hover:bg-[#2f5241e1] transition-colors duration-200 text-white text-xs md:text-sm px-1 md:px-2 py-1.5 md:py-2 rounded w-full max-w-xs"
      />
      <InfoTooltip>
        Upload a PDF, JPEG or PNG file with the survey/terrain/lot plan or
        image. You'll usually find this document in your downloads folder or
        photos.
        <br />
        This function is only enabled on computer (PC or laptop).
      </InfoTooltip>
      {isSurveyLoaded && (
        <p className="text-green-600 text-sm mt-2">
          Survey loaded successfully!
        </p>
      )}
    </Section>
  );
}
